export default __webpack_public_path__ + "static/media/belt_of_tribulation.2c031034.jpg";